export default "__VITE_ASSET__DOc6yaoJ__"